import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendServiceService } from './backend-service.service';

@Injectable({
  providedIn: 'root'
})
export class NewsServiceService {

  constructor(private httpClient:HttpClient,private backendService:BackendServiceService) { }

  saveDetails(details:any){
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL+'news/addnews?mds='+token,details);
  }

  getAllDetails(){
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiLocalUrl+'news/getallnews?mds='+token);
   
  }

  getNewsDetailsById(newsId:any){
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiSystemAdminURL+'news/getnewsdetilsbyid?id='+newsId+'&mds='+token);
  }

  getNewsDetailsByKeywords(newsKeywords:any){
    let token = localStorage.getItem("token");
    return this.httpClient.get<any>(this.backendService.apiSystemAdminURL+'news/getnewsdetilsbykeywords?newsKeywords='+newsKeywords+'&mds='+token);
  }

  editImage(details:any){
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL+'news/editnewsimage?mds='+token,details);
  }

  editDetails(details:any){
    let token = localStorage.getItem("token");
    return this.httpClient.post<any>(this.backendService.apiSystemAdminURL+'news/editnewsdetails?mds='+token,details);
  }

  
}
